@if (section(); as s) {
  <app-section-wrapper
    [id]="s.id"
    [title]="s.title"
    [background]="s.background"
  >
    <div class="problem-grid stagger">
      @for (item of s.items; track item.title) {
        <div class="problem-card">
          <div class="problem-card__icon">
            <mat-icon>{{ item.icon }}</mat-icon>
          </div>
          <h3 class="problem-card__title">{{ item.title }}</h3>
          <p class="problem-card__desc">{{ item.description }}</p>
        </div>
      }
    </div>
  </app-section-wrapper>
}
